import React, { Component } from 'react';
import { AuthConsumer } from 'react-check-auth';
import { Route, Switch, Link } from 'react-router-dom';


class LoginButton extends Component {
  render() {
    return (
      <AuthConsumer>
        {({refreshAuth, userInfo}) => {
          let logout = () => {
            fetch("/logout", {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({'logout': 'session'}),
              credentials: 'include'
            }).then(function(response) {
              return response.json();
            }).then(function(result) {
              window.location.replace(result['redirect_url']);
            });
          }
          return (
            <Switch>
              <Route path="/login">
              </Route>
              <Route path="/logout">
              </Route>
              <Route path="/">
                { userInfo ? (
                    <button className={this.props.className} onClick={logout}>Logout</button>
                  ) : (
                    <Link to={ userInfo ? '/logout' : '/login' }>
                      <button className={this.props.className}>{ userInfo ? 'Logout' : 'Login' }</button>
                    </Link>
                  )
                }
              </Route>
            </Switch>
          );
        } }
      </AuthConsumer>
    );
  }
}

export default LoginButton;



// WEBPACK FOOTER //
// ./src/LoginButton.jsx